export default __webpack_public_path__ + "static/media/ALFA-PIZZA cyprus.76492180.png";